export const indiciesForLength = (n:number): number[] => inclusiveRange(0,n-1);
export const inclusiveRange = (low:number,high:number): number[] => {
  const r = [];
  for (let i = low; i <= high; i++) {
    r.push(i);
  }
  return r;
};
